import {
	BenefitItemContentSX,
	BenefitImgContainerSX,
	BenefitItemTitleSX,
} from '@/components/blocks/ProductDetails/styles/benefitsMobile';
import { ButtonBase, Typography, Stack } from '@mui/material';
import { Img } from '@/components/blocks/MaterialImage';
import React, { FC, useState } from 'react';
import { DrawerBenefit } from '@/components/blocks/DrawerBenefit';

export const ProductDetailsBenefitsMobileDisplay: FC = () => {
	const [openDrawer, setOpenDrawer] = useState<
		| {
				title: string;
				emsName: string;
		  }
		| undefined
	>(undefined);

	const handleOpenDrawer = (title: string, emsName: string) => () => {
		setOpenDrawer({ title, emsName });
	};

	const handleCloseDrawer = () => {
		setOpenDrawer(undefined);
	};

	return (
		<React.Fragment>
			<Stack
				spacing={'18px'}
				sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'start',
					border: 0,
					backgroundColor: 'transparent',
					paddingTop: '13px',
					paddingBottom: '13px',
				}}
			>
				<ButtonBase
					sx={BenefitItemContentSX()}
					onClick={handleOpenDrawer('Entregas y Envíos', 'DrawerDeliveriesShipmentsInformative')}
				>
					<Stack
						sx={BenefitImgContainerSX()}
						direction={'row'}
						spacing={'12px'}
						alignItems={'center'}
					>
						<Stack direction={'row'} width={'30px'} justifyContent={'center'}>
							<Img
								src="EmeraldSAS/images/promotion/home/icon_benefits_2_black.svg"
								height={'25px'}
							/>
						</Stack>
						<Typography sx={BenefitItemTitleSX()}>{'Envío gratis en compras +$999'}</Typography>
					</Stack>
				</ButtonBase>

				<ButtonBase
					sx={BenefitItemContentSX()}
					onClick={handleOpenDrawer('Cambios y Devoluciones', 'DrawerReturnsExchangesInformative')}
				>
					<Stack
						sx={BenefitImgContainerSX()}
						direction={'row'}
						spacing={'12px'}
						alignItems={'center'}
					>
						<Stack direction={'row'} width={'30px'} justifyContent={'center'}>
							<Img
								src="EmeraldSAS/images/promotion/home/icon_benefits_1_black.svg"
								height={'25px'}
							/>
						</Stack>

						<Typography sx={BenefitItemTitleSX()}>{'30 días de cambio o devoluciones'}</Typography>
					</Stack>
				</ButtonBase>

				<ButtonBase
					sx={BenefitItemContentSX()}
					onClick={handleOpenDrawer('Formas de Pago', 'DrawerPaymentMethodsInformative')}
				>
					<Stack
						sx={BenefitImgContainerSX()}
						direction={'row'}
						spacing={'12px'}
						alignItems={'center'}
					>
						<Stack direction={'row'} width={'30px'} justifyContent={'center'}>
							<Img
								src="EmeraldSAS/images/promotion/home/icon_benefits_3_black.svg"
								height={'25px'}
							/>
						</Stack>

						<Typography sx={BenefitItemTitleSX()}>{'Conoce las formas de pago'}</Typography>
					</Stack>
				</ButtonBase>
			</Stack>
			<DrawerBenefit
				open={!!openDrawer}
				title={openDrawer?.title || ''}
				emsName={openDrawer?.emsName || ''}
				onClose={handleCloseDrawer}
			/>
		</React.Fragment>
	);
};
